import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { C } from '../constants';

import { connect } from 'react-redux';
import { Platform, StyleSheet, View, Alert, BackHandler } from 'react-native';
import { Content } from "native-base";
import SearchDialog from './SearchDialog';
import ComponentRouter from './ComponentRouter';

import Login from './Login';
import Registration from './Registration';
import EmailConfirm from './EmailConfirm';
import GetEmailConfirm from './GetEmailConfirm';
import BreathTest from './BreathTest';

import Alerts from './_Alerts';

import {
  setCurrentAction,
  checkAuthKey,
  getBlockByUrl,
  updateUserData,
  goBack
} from '../actions';

class Ask extends Component {
  state = {
    visible: false,
    code: '',
    email: ''
  };

  componentDidMount() {
    if (Platform.OS === 'web' && C.CATCH_EXIT) {
      let self = this;

      window.addEventListener('beforeunload', function (e) {
        self.props.dispatch(getBlockByUrl(C.CATCH_EXIT_URL));
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = '';
      });
    }

    if (Platform.OS === 'web' && C.AUTH_ENABLED) {
      const { dispatch, currentAction } = this.props;
      let hash = window.location.hash || '#';

      //@todo delete
      // if (localStorage.getItem('authkey') === 'testKey') {
      //     localStorage.setItem('authkey', '');
      // }

      // localStorage.setItem('authkey', 'testKey');

      hash = hash.slice(1);
      let params = new URLSearchParams(hash);
      let action = params.get("action");
      let code = params.get("code");
      let email = params.get("email");

      if (currentAction !== action) {
        dispatch(setCurrentAction(action));
      }

      if (code && email) {
        this.setState({ code, email });
      }

      if (action !== 'confirm') {
        dispatch(checkAuthKey());
      }
      this.props.dispatch(getBlockByUrl());
    } else {
      this.props.dispatch(getBlockByUrl());
      this.backHandler = BackHandler.addEventListener("hardwareBackPress", this.backAction);
    }
  }

  componentWillUnmount() {
    this.backHandler.remove();
  }

  hasValue = () => {
    const { userData } = this.props;
    let hasValue = false;

    userData.blocks.forEach(block => {
      if (block.type !== 'BUTTON' && block.value && block.value.length) {
        hasValue = true;
      }
    });

    return hasValue;
  }

  hasSelectors = () => {
    const { userData } = this.props;
    let hasSelectors = false;

    userData.blocks.forEach(block => {
      if (block.type === 'CHECKBOX' || block.type === 'RADIOBUTTON') {
        hasSelectors = true;
      }
    });

    return hasSelectors;
  }

  hasRequiredFields = () => {
    const { userData } = this.props;
    let hasRequiredFields = false;

    userData.blocks.forEach(block => {
      if (block.required && block.type !== 'BUTTON') {
        hasRequiredFields = true;
      }
    });

    return hasRequiredFields;
  }

  getButtonLabel = () => {
    const { userData } = this.props;
    let disabled = false;

    userData.blocks.forEach(block => {
      if (block.required && block.type !== 'BUTTON' && (block.value === undefined || block.value.length === 0)) {
        disabled = true;
      }
    });

    return disabled;
  }

  handlerChangeValue = ({ block, value, label }) => {
    const { dispatch } = this.props;

    if (value !== undefined) {
      if (!Array.isArray(value)) {
        value = ["" + value];
      }
      const name = block.name || '';
      dispatch(updateUserData({ name, value, label }));
    }
  }

  backAction = () => {
    const { dispatch, history } = this.props;

    if (history.length > 1) {
      dispatch(goBack());
    } else {
      Alert.alert("", "Закрыть приложение?", [
        {
          text: "Отмена",
          onPress: () => null,
          style: "cancel"
        },
        {
          text: "Закрыть",
          onPress: () => BackHandler.exitApp()
        }
      ]);
    }

    return true;
  };

  render() {
    const { userData, currentAction } = this.props;
    const { email, code } = this.state;

    const isBreathTest = userData.mainType === "TEST_BREATH";

    if (Platform.OS === 'web' && C.AUTH_ENABLED) {
      let page;
      switch (currentAction) {
        case 'login':
          page = <Login />;
          break;
        case 'registration':
          page = <Registration />;
          break;

        case 'registrationSuccess':
          page = <Registration />;
          break;
        case 'interface':
          page = '';
          break;
        case 'confirm':
          page = <EmailConfirm email={email} code={code} />;
          break;
        case 'getconfirm':
          page = <GetEmailConfirm email={email} />;
          break;
        case 'confirmSuccess':
          page = <Login />;
          break;
        default:
          page = '';
      }


      if (currentAction !== 'interface') {
        return <>{page}<Alerts /></>;
      }
    }

    {/* <ScrollView   keyboardShouldPersistTaps={"always"}  style={{flex:1}}></ScrollView> */ }
    return (
      <>
        <View
          contentContainerStyle={styles.content}>
          <Content>
            {isBreathTest ? <BreathTest /> : userData.blocks.map((block, i) => {
              return <ComponentRouter key={i} block={block} />;
            })}
          </Content>
          <Alerts />
        </View>
        <SearchDialog onChange={this.handlerChangeValue} />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state.userData,
    history: state.history,
    alerts: state.alerts,
    currentAction: state.currentAction
  };
}

Ask.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object,
  history: PropTypes.array,
  currentAction: PropTypes.string
};

export default connect(mapStateToProps)(Ask);

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },
  card: {
    width: '100%'
  },
  cardItem: {
    marginTop: '1%'
  },
  content: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  }
});
